export enum EnumMobileWarningPageAck {
  Dashboard = 'MobileAckDashboard',
  Postings = 'MobileAckPostings',
  Promote = 'MobileAckPromote',
  Report = 'MobileAckReport',
  Feed = 'MobileAckFeed',
  Billing = 'MobileAckBilling',
  Users = 'MobileAckUsers',
  Brands = 'MobileAckBrands',
  Locations = 'MobileAckLocations',
  Audit = 'MobileAckAudit',
}
